import Types from './Types';

const INITIAL_STATE = {
    announcements: [],
    isLoading: false,
    count: ''
};

export default function studentAnnouncements(state = INITIAL_STATE, action) {
    const { type, payload } = action;
    switch (type) {
        case Types.GET_ACTIVE_ANNOUNCEMENTS_SUCCESS: {
            // Handle both cases: payload.data (wrapped) or payload (direct array)
            const announcementsData = Array.isArray(payload.data) ? payload.data : (Array.isArray(payload) ? payload : []);
            return {
                ...state,
                announcements: announcementsData,
                count: announcementsData.length
            };
        }

        case Types.ADD_ANNOUNCEMENTS_LOADING: {
            return {
                ...state,
                isLoading: payload
            };
        }

        default: {
            return state;
        }
    }
}

